<div
  class="bottom-sheet"
  [class.block-overlay]="opt.blockOverlay"
  [class.show-tabbar]="!!opt.showTabbar && !showKeyboard()"
  [class.keyboard-open]="showKeyboard()"
  [class.is-dragging]="isDragging()"
>
  @if (isBackdropVisible()) {
    <div class="bottom-sheet-backdrop" role="presentation" (click)="onBackdropClick($event)"></div>
  }
  <div
    [style.height.px]="sheetHeight()"
    class="bottom-sheet-container"
    [class]="'theme-' + opt.background"
    [class.container-fixed]="!opt.blockOverlay"
    [style]="opt.styleContainer"
    (sdClickOutside)="onClickOutside()"
    #draggableItem
    cdkDrag
    [cdkDragLockAxis]="'y'"
    [cdkDragDisabled]="showKeyboard()"
    (cdkDragStarted)="onDragStarted($event)"
    (cdkDragMoved)="onDragMoved($event)"
    (cdkDragEnded)="onDragEnded($event)"
  >
    <div class="bottom-sheet-drag-area">
      <div class="bottom-sheet-anchor" cdkDragHandle #dragHandle>
        @if (!opt.hideAnchor) {
          <div class="anchor"></div>
        }
      </div>

      @if (opt.hasCloseButton) {
        <div class="bottom-sheet-close-button">
          <button class="btn-icon" (click)="onClose()" aria-label="close">
            <sd-icon [type]="iconTypes.CROSS" class="icon-size-s icon-size-md-m icon-size-lg-l"></sd-icon>
          </button>
        </div>
      }

      @if (opt.title) {
        <div class="bottom-sheet-header">
          <h3 id="bottom-sheet-title" class="bottom-sheet-header-title text-h6-s text-md-h4-s">{{ opt.title }}</h3>
        </div>
      }
    </div>

    <div class="bottom-sheet-body" [style]="opt.style">
      <ng-content></ng-content>
    </div>
  </div>
</div>
